import { z } from "zod";

export const tenantTimezoneSchema = z.object({
	tenantId: z.string().optional(),
	siteTimeZoneOffset: z.number().optional(),
	siteTimeZone: z.string(),
	siteTimeZoneLabel: z.string().optional(),
	siteTimeZoneAltName: z.string().optional(),
	siteTimeZoneAbbreviation: z.string().optional(),
});

export type TenantTimezone = z.infer<typeof tenantTimezoneSchema>;
